export const HOST =
  import.meta.env.VITE_SPACETIMEDB_HOST ?? 'ws://localhost:3000';
export const DB_NAME =
  import.meta.env.VITE_SPACETIMEDB_DB_NAME ?? 'heartwood';
